import * as React from 'react';
import AxiosSingletonLoader from 'src/component/Global/AxiosSingletonLoader';
import System from "../../helper/system";


const AddToBom = (props) => {
    const { single_product, isBomPLP, bomNoMatchType } = props;
    const bomId = System.getParams().bomId
    const bomDetailId = System.getParams().bomDetailId
    const { translation: t } = System;

    const getDisplayStatus = () => {
        return !!(single_product && isBomPLP)
    };

    const addToBomOrSwap = () => {
        System.popup('AddedToBomPopup', { single_product: single_product, bomId, bomDetailId, bomNoMatchType })
    };

    return (
        <>
            {(getDisplayStatus() &&
                <>
                    <AxiosSingletonLoader
                        customAxiosButtonIndicatorRunTimeLoader={true}
                        slugKey={['BOM_SWAP_PART_NUMBER_API_CALL', 'PRODUCT_LISTING_API_CALL', 'BOM_OPERATION_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'CART_API_CALL']}>
                        <button onClick={() => {
                            addToBomOrSwap()
                        }} className="bs5 btn btn-primary w-100">{t('addToBom')}
                        </button>
                    </AxiosSingletonLoader>

                </>
            )
            }
        </>

    );
};

export default AddToBom;